import type { FactionDefinition } from "@/types/game-data";

export const FACTIONS: readonly FactionDefinition[] = [
	{
		id: "militia",
		name: "Insurgent Force (Militia)",
		description:
			"Irregular fighting forces composed of volunteers, criminals, insurgents, warlords, paramilitary factions, or resistance fighters. They rely on captured or black-market weapons, improvised vehicles, and home-built explosive devices. Embrace asymmetry, unpredictability, and escalation through chaos.",
		availableTiers: ["militia"],
	},
	{
		id: "taskforce",
		name: "Task Force",
		description:
			"Highly trained, heavily resourced elite formations composed of Tier 1 and Tier 2 Operators, veterans, and enlisted soldiers. They conduct rapid intervention, counter-terror operations, covert surveillance, hostage rescues, or high-value target elimination with advanced equipment and integrated communications.",
		availableTiers: ["tier1", "tier2", "veteran", "enlisted"],
	},
	{
		id: "russian",
		name: "Russian Forces",
		description:
			"The Russian army and its special forces are extremely varied in their composition, training and equipment. This list allows you to build an approximation of a variety of modern Russian Forces, from untrained and poorly equipped Conscript fighters to highly trained and well equipped Special Operations Forces.",
		availableTiers: ["tier1", "tier2", "veteran", "enlisted", "conscript"],
	},
	{
		id: "law-enforcement",
		name: "Law Enforcement",
		description:
			"A flexible force centered around a core of SWAT teams. These teams can be equipped in a way to make them very flexible, allowing them to respond to a number of threats, from overt siege style missions to covert, complex scenarios. Supported by patrol officers and armoured vehicles.",
		availableTiers: ["veteran", "enlisted"],
	},
	{
		id: "criminal-element",
		name: "Criminal Element",
		description:
			"A versatile list that allows you to build a variety of Criminal Element forces anywhere in the world, from lowly street thugs, traffickers, and narcotic-addled squatters to serious organised criminals kitted out for a sophisticated bank heist. Particularly useful with Non-Player Element rules.",
		availableTiers: ["veteran", "criminal"],
	},
] as const;
